import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider, Layout } from "antd";
import Dashboard from "./pages/Dashboard";
import CaseView from "./pages/CaseView";
import NewCase from "./pages/NewCase";
import AIAssistant from "./pages/AIAssistant";
import ReferenceCatalog from "./pages/ReferenceCatalog";
import Sidebar from "./components/Sidebar";
import "./App.css";

const { Content } = Layout;

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1890ff",
          borderRadius: 6,
        },
      }}
    >
      <Router>
        <Layout style={{ minHeight: "100vh" }}>
          <Sidebar />
          <Layout>
            <Content
              style={{ margin: "24px 16px", padding: 24, background: "#fff" }}
            >
              <Routes>
                <Route path="/" element={<ReferenceCatalog />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/case/:caseId" element={<CaseView />} />
                <Route path="/new-case" element={<NewCase />} />
                <Route path="/ai-assistant" element={<AIAssistant />} />
              </Routes>
            </Content>
          </Layout>
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;
